<script setup>
import { CalendarGridBody } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: false },
  as: { type: String, default: undefined },
});
</script>

<template>
  <CalendarGridBody v-bind="props">
    <slot />
  </CalendarGridBody>
</template>
